// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-menu-item > p svg {
  fill: currentColor;
  max-height: 1rem /* 16px */;
  max-width: 16px;
  margin-right: 0.5rem /* 8px */;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/account/AccountMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,8BAA8B;AAChC","sourcesContent":[".account-menu-item > p svg {\n  fill: currentColor;\n  max-height: 1rem /* 16px */;\n  max-width: 16px;\n  margin-right: 0.5rem /* 8px */;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
